import { APICore } from "./apiCore";

const api = new APICore();

const listarEstados = (query: string) => {
    return api.get(`/estado?${query}`);
};

export { listarEstados };
